import clsx from 'clsx';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name'> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  className?: string;
  id?: string;
  required?: boolean;
  disabled?: boolean;
  name: string;
}

export function Input({
  label,
  error: propError,
  icon,
  className,
  id,
  required,
  disabled,
  name,
  ...props
}: InputProps): JSX.Element {
  const form = useFormContext();
  const error = propError || (form?.formState?.errors[name]?.message as string);

  return (
    <div className="w-full space-y-1">
      {label && (
        <label
          htmlFor={id || name}
          className="flex-1 text-md font-normal leading-6 text-gray-600"
        >
          {label}
          {required && <span className="text-primary ml-1">*</span>}
        </label>
      )}
      <div className="relative w-full">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">{icon}</span>
          </div>
        )}
        <input
          id={id || name}
          disabled={disabled}
          {...(form ? form.register(name) : { name })}
          {...props}
          className={clsx(
            'flex h-[40px] w-full items-center justify-center gap-3 self-stretch',
            'px-3 py-[10px]',
            'rounded-[6px] border border-gray-300',
            disabled
              ? 'bg-[rgba(0,0,0,0.04)] text-[#8C8C8C]'
              : 'bg-[#FEFDFC] text-[#141414]',
            'text-md font-normal leading-6',
            'outline-none',
            error && 'border-red-300 text-red-900 placeholder-red-300',
            className,
          )}
        />
      </div>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
